import Http from "./http";

export const getMaterialDetailsAPI = (payload) => {
  return Http.post("admin/material/get", payload);
};
